/**
 * Media queries the chat shell shares.
 *
 * `BELOW_MD` is Mantine's own `md` as a `max-width`, matching `hiddenFrom="md"` — the point where
 * the layout loses its sidebar. `PHONE` is narrower and is not a Mantine step at all: it is where
 * a 430px-wide device leaves too little room for the composer's centred measure and for a five-part
 * banner on one line, and Mantine's nearest breakpoint (`xs`, 576px) is a phone-and-a-half wide.
 *
 * Plain `.ts` rather than `.css.ts` so both stylesheets and components can read them; a `.css.ts`
 * file may only export serialisable values, and these are consumed as keys.
 */

/** @desc Below Mantine's `md` (992px): the tablet-and-under layout. */
export const BELOW_MD = '(max-width: 61.99em)';

/** @desc 430px and under: a phone held in one hand, the widest common handset in portrait. */
export const PHONE = '(max-width: 26.875em)';

/**
 * @desc A phone on its side: under 500px tall and under the `md` sidebar breakpoint (H2-234).
 *
 * Every handset in landscape is both (the tallest, a Pro Max, is 440px by 932px); a tablet on its
 * side is not (744px+ tall), and neither is a desktop window that is merely short — above `md` the
 * chat has no sub-header to lift. The stylesheets lay the top chrome over the transcript here, and
 * `useHideOnScroll` reads the same string through `matchMedia`, so the two cannot disagree about
 * which viewport they are in.
 */
export const SHORT_LANDSCAPE =
  '(orientation: landscape) and (max-height: 31.25em) and (max-width: 61.99em)';
